module.exports = __webpack_public_path__ + "static/media/icon_expand.1731b1a1.svg";